export const RESTAURANT_SOFTWARE_ORDIT = 'ordit'

export default {
    ordit: RESTAURANT_SOFTWARE_ORDIT,
}
